import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  to: string;
  label: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to, label }) => {
  const navigate = useNavigate();

  return (
    <button 
      onClick={() => navigate(to)}
      style={{ 
        background: 'none', 
        border: 'none', 
        color: '#0d6efd', 
        cursor: 'pointer',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: 0
      }}
    >
      <span>←</span> {label}
    </button>
  );
};

export default BackButton;
